import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { navigate } from 'gatsby'

// Theme
import Theme from 'styles/Global'

// Components
import Footer from 'components/layout/Footer'
import Header from 'components/layout/Header'
import VacancyModal from 'components/elements/Modal'

// CSS
import 'styles/all.css'

export interface LayoutContextProps {
  locale: string
  translations: Array<{
    href: string
    locale: string
  }>
  setIsScrollable: Function
  setVacatureModal: Function
}

export const LayoutContext = React.createContext({
  locale: 'nl_NL',
  translations: [],
  setIsScrollable: (bool: boolean) => bool,
  setVacatureModal: (bool: boolean) => bool,
})

const Content = styled.div<{ isSticky?: boolean }>`
  @media (min-width: 992px) {
    padding-top: 80px;
  }

  @media (max-width: 991px) {
    padding-top: 70px;
  }
`

interface LayoutProps {
  children: any
  locale?: string
  translations?: any
  location?: any
}

const Layout: React.FC<LayoutProps> = ({ children, locale, translations, location }) => {
  const [isSticky, setSticky] = useState<boolean>(false)
  const [isScrollable, setIsScrollable] = useState<boolean>(true)
  const [vacatureModal, setVacatureModal] = useState<boolean>(false)

  const handleScroll = () => {
    setSticky(window.scrollY > 0)
  }

  useEffect(() => {
    window.addEventListener('scroll', handleScroll)

    return () => {
      window.removeEventListener('scroll', () => handleScroll)
    }
  }, [handleScroll])

  useEffect(() => {
    if (location && location.pathname === '/') {
      setVacatureModal(true)
    }
  }, [location]) 
  

  return (
    <Theme isScrollable={isScrollable}>
      {/* @ts-ignore */}
      <LayoutContext.Provider value={{ setIsScrollable, locale, translations }}>
        <Header isSticky={isSticky} setIsScrollable={setIsScrollable} />
        <Content isSticky={isSticky} className="containerize bg-black">{children}</Content>
        {/* {vacatureModal && <VacancyModal setEventModal={setVacatureModal} />} */}
        <Footer />
      </LayoutContext.Provider>
    </Theme>
  )
}

export default Layout
